import { ProviderInvoiceDetailSourceEnums } from "src/app/enum/provider-invoice-detail-source-enums";

export class ProviderInvoiceDetailBulkItemModel {
  // purchaseOrder: purchaseOrderDetailId | inventoryEntry: inventoryEntryDetailId | others: articleId
  sourceId: number = 0;
  conceptInvoicingId: number | null = null;
  // null = el back toma la cantidad pendiente del documento origen
  quantity: number | null = null;
}

export class ProviderInvoiceDetailBulkModel {
  providerInvoiceId: number = 0;
  source: ProviderInvoiceDetailSourceEnums = ProviderInvoiceDetailSourceEnums.others;
  items: ProviderInvoiceDetailBulkItemModel[] = [];
}
